const translation_he = {
  hello: "שלום",
  welcome: "ברוכים הבאים לבנק שלי",
  'Enter': 'התחברות',
  'Create new account': "יצירת חשבון",
  Home: "דף הבית",
  menu: "תפריט",
  private: "פרטי",
  Logout: 'התנתקות',
  'Credit card' : 'כרטיס אשראי',
  'Update details' : 'עדכון פרטים',
  'Transfer money' : 'העברת כספים',
  Business: "עיסקי",
  'Cancel' : 'ביטול',
  loan : 'הלוואה',
  transfer : 'העברה',
  support: "תמיכה",
  'sign in': "התחבר",
  'sign up': "הרשם",
  details: "פרטים",
  logout: "יציאה",
  balance: "יתרה",
  'transfer money': "העברת כספים",
  'Current account': "עובר ושב",
  Transfer: "העברה",
  income: "הכנסה",
  Loan: "הלוואה",
  email: "אימייל",
  password: "סיסמא",
  'update details' : 'עדכון פרטים',
  'confirm password' : 'סיסמא חוזרת',
  about : 'אודות',
  username : 'שם משתמש',
  price : 'סכום',
  copyright : 'זכויות יוצרים על ידי ליאור אהרון 2023',
  'max loan' : 'הלוואה מקסמילית',
  usernameToTransfer : 'למי להעביר',
  "searching user" : 'מחפש משתמש',
  upload : 'העלאה',
  loading : 'טוען',
  exit : 'יציאה',
  'you are going to make action are you sure' : ' אתה עומד לבצע פעולה האם אתה בטוח',
  'fill please' : 'נא למלא פרטים',
  Personal : 'איזור אישי',
  'have an account' : 'קיים במערכת',
  'request has been declined' : "ההצעה נדחתה",
  'loan-page' : 'פרטי התהליך אושרו אנא לחץ על אישור',
  'transfer-page' : 'פרטי התהליך אושרו אנא לחץ על אישור ',
  'order-page' : 'אתה עומד לבצע הזמנה האם אתה בטוח?',
  approve : 'אישור',
  accept : 'מאשר',
  order : 'הזמן',
  'order card' : 'הזמן כרטיס',
  register: 'הירשם',
  'dont have an account' : 'אין חשבון',
  students : 'סטודנטים',
  accessibility : 'נגישות',
  contact : 'יצירת קשר',
  help : 'עזרה',
  chat : 'צאט',
  'credit card' : 'כרטיס אשראי',
  services : 'שירותים',
  branches : 'סניפים',
  'already have an account' : 'יש חשבון',
  status : 'סטטוס',
  maxLoan : 'הלוואה מקסימלית',
  Bank : 'בנק',
  english : 'אנגלית',
  hebrew : 'עברית',
  'card number' : 'מספר כרטיס',
  'expiration date' : 'תאריך תפוגה',
  'upload profile picture' : 'העלאת תמונה פרופיל',
  'users not found' : ' משתמש לא נמצא',
  'please fill data' : 'נא למלא פרטים',
  business : 'עסקים',
  'your balance' : 'היתרה שלך',
  'we not allowed to be at overdraft' : 'אנחנו לא מאשרים להיות בחריגה',
  'this route is not exist please go back to homepage' : 'הנתיב לא נמצא נא לחזור לדף הבית',
  homepage : 'דף הבית',
  'user not found' : 'משתמש לא נמצא',
'change username' : 'שנה שם משתמש',
'change password' : 'שנה סיסמא',
'change email' : 'שנה אימייל',
'received':'התקבל',
date : 'תאריך',
action : 'פעולה',
change : 'שנה'
  
};
export default translation_he;
